import { render } from "./UserRegister.vue?vue&type=template&id=14f8f3b8&scoped=true"
import script from "./UserRegister.vue?vue&type=script&lang=js"
export * from "./UserRegister.vue?vue&type=script&lang=js"

import "./UserRegister.vue?vue&type=style&index=0&id=14f8f3b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f8f3b8"]])

export default __exports__